import { httpClient } from '@/lib/api/client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { env } from '@/lib/config/env';
import { mockApi } from '@/lib/api/mock/adapter';
import type { Permission } from '@/lib/config/constants';
import type { RoleDefinition } from '@/store/rolesStore';

export interface CreateRoleInput {
  label: string;
  permissions: Permission[];
}

export interface RolesRepository {
  list(): Promise<RoleDefinition[]>;
  create(input: CreateRoleInput): Promise<RoleDefinition>;
  update(id: string, permissions: Permission[]): Promise<RoleDefinition>;
  remove(id: string): Promise<void>;
}

const normalize = (roles: RoleDefinition[]): RoleDefinition[] =>
  roles.map((r) => ({ ...r, permissions: r.permissions ?? [] }));

const http: RolesRepository = {
  list: async () => normalize(await httpClient.get<RoleDefinition[]>(ENDPOINTS.roles.list)),
  create: (input) => httpClient.post<RoleDefinition>(ENDPOINTS.roles.create, input),
  update: (id, permissions) =>
    httpClient.put<RoleDefinition>(ENDPOINTS.roles.detail(id), { permissions }),
  remove: (id) => httpClient.delete<void>(ENDPOINTS.roles.detail(id)),
};

const mock: RolesRepository = {
  list: () => mockApi.listRoles(),
  create: (input) => mockApi.createRole(input),
  update: (id, permissions) => mockApi.updateRole(id, permissions),
  remove: (id) => mockApi.deleteRole(id),
};

export const rolesRepository: RolesRepository = env.useMockApi ? mock : http;
